/**
 * Who may edit settings/rules. MCV2 has no role field on `users` docs (verified 2026-11-04:
 * fields are uid, name, email, Organization, fulfillmentAssignable…), so "ops admin" = a
 * signed-in user whose users doc has Organization === 'topicz'. Vendors (other orgs) get
 * read-only. Firestore rules mirror this at the signed-in level only (see firestore.rules).
 */
import { useFirebaseAuth } from 'context/FirebaseAuthContext';
import useRoleData from 'hooks/useRoleData';

export const OPS_ORGANIZATION = 'topicz';

export function useRateShopAccess() {
  const [user, authLoading] = useFirebaseAuth();
  const [roleData, orgData, userLoading, userError] = useRoleData(user?.uid);
  const loading = authLoading || userLoading;
  const canEdit = !loading && !userError && orgData === OPS_ORGANIZATION;
  return { canEdit, loading, userError, roleData, orgData, user };
}
